import React from 'react';
import { Stack, Typography, useTheme, styled } from '@mui/material';

import { Container } from '@/components/layout';

const BackgroundStack = styled(Stack)`
  background-image: url(/images/about-us/hero-bg.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;

function Hero() {
  const theme = useTheme();

  return (
    <BackgroundStack
      sx={{
        minHeight: { xs: '500px', md: '379px' },
        justifyContent: 'flex-end',
        paddingBottom: { xs: theme.spacing(7.5), md: theme.spacing(16.75) },
      }}
    >
      <Container>
        <Stack
          sx={{
            gap: { xs: theme.spacing(2.5), md: theme.spacing(3) },
          }}
        >
          <Typography
            variant="h1"
            sx={{
              color: theme.palette.common.white,
              fontSize: {
                xs: '2.375rem !important',
                lg: '3.125rem !important',
              },
              lineHeight: { xs: '1.2 !important', lg: '1.18 !important' },
            }}
          >
            We’re glad to meet you
          </Typography>

          <Typography
            variant="body2"
            color={theme.palette.common.white}
            sx={{
              fontSize: { xs: '1.125rem !important', md: '1.25rem !important' },
              lineHeight: { xs: '1.46 !important', md: '1.33 !important' },
            }}
          >
            We’re a personalized health platform that will have you wondering:
            How did we do health before? We offer a better health experience for
            employers and their people. Customized coaching. Simplified benefits
            management. Engaging programs. You name it. We’re empowering people
            to lead healthier lives.
          </Typography>
        </Stack>
      </Container>
    </BackgroundStack>
  );
}

export default Hero;

